import React, { useState } from 'react'
import AssignId from '../AssignId'
import Container from '../Container'
import styles from './Scaglie.module.sass'
import VisibilitySensor from '../VisibilitySensor'
import PhotoModal from './PhotoModal'
import { ScagliePageConfig } from '../configuration'

export default function Scaglie() {

  const conf = ScagliePageConfig;
  const [activeImage, setActiveImage] = useState(0)

  return (
    <Container size="md">
      <div className={styles.root}>
        <AssignId
          absolute
          y='-120px'
          yMobile='-80px'
          id={conf.id}
        />
        <VisibilitySensor index={4} />
        <div className={styles.layout}>

            <div className={`${styles.galleryBox}`}>
                <div className={styles.powerBarBox}>
                    <div className={styles.powerBar}>
                        {conf.images.map((x, index) => (
                            <button
                                key={index}
                                type="button"
                                onClick={() => {
                                  setActiveImage(index);
                                  if (window.dataLayer) {
                                    window.dataLayer.push({
                                      'event': 'lp_cta_body',
                                      'cta_clicked': x.label,
                                      'section': 'Osmos'
                                    });
                                  }
                                }}
                                className={`${styles.powerBarItem} ${index === activeImage ? styles['powerBarItem--active'] : ''} `}
                            >{x.label}</button>
                        ))}
                    </div>
                </div>
                <div className={styles.imageBox}>
                    {conf.images.map((x, index) => (
                        <div key={`image-${index}`} className={`${styles.zoom} ${index === activeImage ? styles['zoom--active'] : ''}`}>
                            <PhotoModal key={index} img={x.src} zoomedImg={x.srcZoomed} />
                        </div>
                    ))}
                </div>
            </div>
          <div className={`${styles.content} scroll-fadein`}>
            <p className={styles.intro}>{conf.intro}</p>
            <h2 className={styles.title}>{conf.titolo}</h2>
            <div className={styles.description}>{conf.descrizione}</div>
            <div className={styles.formati}>
              <h3 className={styles.formatiTitle}>{conf.formati.titolo}</h3>
              <div className={styles.formatiList}>
                {conf.formati.items.map((x, index) => (
                  <div className={styles.formatiItem} key={index}>
                    <img src={x.src} alt={x.titolo} />
                    <div className={styles.formatiItemContent}>
                      <p className={styles.formatiItemTitle}>{x.titolo}</p>
                      <p className={styles.formatiItemDescription}>{x.sottotitolo}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}